var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e57e25",
    d: "M31.037 1.566A13.805 13.805 0 0 1 33 5.972a10.487 10.487 0 0 1 4.329-2.692.891.891 0 0 1 1.111 1.12A8.786 8.786 0 0 0 38 6.972c9.857-3.035 15.625 4.286 17.869 8a.891.891 0 0 1-.955 1.333A15.609 15.609 0 0 0 52 15.977s4 3 4 14.008a34.8 34.8 0 0 1-2.042 11.846.9.9 0 0 1-1.672 0A11.706 11.706 0 0 0 50 37.989 18.094 18.094 0 0 1 43.118 53.2a.9.9 0 0 1-1.376-.341A3.53 3.53 0 0 0 40 51s-3.99 7-10 8c-6.009-1-10-8-10-8a3.53 3.53 0 0 0-1.743 1.858.9.9 0 0 1-1.376.341A18.094 18.094 0 0 1 10 37.989a11.706 11.706 0 0 0-2.286 3.843.9.9 0 0 1-1.672 0A34.8 34.8 0 0 1 4 29.985c0-11.006 4-14.008 4-14.008a15.609 15.609 0 0 0-2.915.331.891.891 0 0 1-.955-1.333c2.244-3.717 8.012-11.038 17.869-8A8.786 8.786 0 0 0 21.56 4.4a.891.891 0 0 1 1.111-1.12A10.487 10.487 0 0 1 27 5.972a13.805 13.805 0 0 1 1.963-4.406 1.233 1.233 0 0 1 2.074 0z",
    opacity: 1,
    "data-original": "#e57e25",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3d55b",
    d: "M48 15.29a4.284 4.284 0 0 1-2.01 3.63l-.83.51a2.793 2.793 0 0 0 .11-.76 2.645 2.645 0 0 0-.61-1.69 2.771 2.771 0 0 0-3.35-.66 1.337 1.337 0 0 0-.76 1.2 1.321 1.321 0 0 0 .16.64l1.64 3.01L45 26.05a2.624 2.624 0 0 1-.27 2.92l-3.63 4.45-1.62 1.99.26 1.28a2 2 0 0 1-.85 2.05l-1.39.92a1.965 1.965 0 0 1-1.11.34H33a3.011 3.011 0 0 1-3-3 3.011 3.011 0 0 1-3 3h-3.39a1.965 1.965 0 0 1-1.11-.34l-1.39-.92a2 2 0 0 1-.85-2.05l.26-1.28-1.62-1.99-3.63-4.45a2.624 2.624 0 0 1-.27-2.92l2.65-4.88 1.64-3.01a1.321 1.321 0 0 0 .16-.64 1.337 1.337 0 0 0-.76-1.2 2.771 2.771 0 0 0-3.35.66 2.645 2.645 0 0 0-.61 1.69 2.793 2.793 0 0 0 .11.76l-.83-.51A4.284 4.284 0 0 1 12 15.29a4.231 4.231 0 0 1 .57-2.13 4.28 4.28 0 0 1 5.53-1.76L30 17l11.9-5.6a4.28 4.28 0 0 1 5.53 1.76 4.231 4.231 0 0 1 .57 2.13z",
    opacity: 1,
    "data-original": "#f3d55b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f0c419"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.39 40-.3 3.06a2.029 2.029 0 0 1-.88 1.47l-1.71 1.13a1.957 1.957 0 0 1-1.1.34h-4.8a1.957 1.957 0 0 1-1.1-.34l-1.71-1.13a2.029 2.029 0 0 1-.88-1.47l-.3-3.06H27a3 3 0 0 0 3-3 3 3 0 0 0 3 3z",
    fill: "#f0c419",
    opacity: 1,
    "data-original": "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 31.5v7.73A2.94 2.94 0 0 1 30 37a2.94 2.94 0 0 1-1 2.23V31.5zM20.98 33.2l-.46 2.21-1.62-1.99.12-.62a1 1 0 1 1 1.96.4z",
    fill: "#f0c419",
    opacity: 1,
    "data-original": "#f0c419"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#547580",
    d: "m30 34-3.588-2.988A1.138 1.138 0 0 1 27.141 29h5.718a1.138 1.138 0 0 1 .729 2.012z",
    opacity: 1,
    "data-original": "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f5c6c",
    d: "M26.993 24.68a.819.819 0 0 1-.395.807 3.766 3.766 0 0 1-5.591-2.758.819.819 0 0 1 .395-.807 3.766 3.766 0 0 1 5.591 2.758z",
    opacity: 1,
    "data-original": "#3f5c6c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb7b76",
    d: "M19.45 17.52a1.321 1.321 0 0 1-.16.64l-1.64 3.01-2.81-1.74a2.793 2.793 0 0 1-.11-.76 2.645 2.645 0 0 1 .61-1.69 2.771 2.771 0 0 1 3.35-.66 1.337 1.337 0 0 1 .76 1.2zM45.27 18.67a2.793 2.793 0 0 1-.11.76l-2.81 1.74-1.64-3.01a1.321 1.321 0 0 1-.16-.64 1.337 1.337 0 0 1 .76-1.2 2.771 2.771 0 0 1 3.35.66 2.645 2.645 0 0 1 .61 1.69z",
    opacity: 1,
    "data-original": "#fb7b76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c419",
    d: "m39.48 35.41-.46-2.21a1 1 0 1 1 1.96-.4l.12.62z",
    opacity: 1,
    "data-original": "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f5c6c",
    d: "M33.007 24.68a.819.819 0 0 0 .4.807 3.766 3.766 0 0 0 5.591-2.758.819.819 0 0 0-.4-.807 3.766 3.766 0 0 0-5.591 2.758z",
    opacity: 1,
    "data-original": "#3f5c6c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrave);
export default __webpack_public_path__ + "static/media/brave.ed2f5a6778d22870cd08278fb1b192e6.svg";
export { ForwardRef as ReactComponent };